import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import tw from './assets/i18n/zh-TW.json';
import en from './assets/i18n/en.json';

const resources = {
  // zh 開頭的語言代號都符合，如 zh-TW、zh-CN
  zh: {
    translation: tw,
  },
  // en 開頭的語言代號都符合，如 en-US、en-AU、en-GB、en-NZ
  en: {
    translation: en,
  },
  'zh-CN': {
    translation: en,
  },
};

i18n.use(initReactI18next).init({
  resources,
  // 預設語言
  lng: 'zh',
  // 切換的語言沒有對應的翻譯就用這個語言
  fallbackLng: 'en',
  // 如果語系檔中有巢狀的結構，則 escapeValue 要設為 false，這樣就可以透過物件的方式來取得巢狀內的翻譯
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
